export enum ListMode {
  DEFAULT = 'DEFAULT',
  CHOOSE_ONE = 'CHOOSE_ONE',
  CHOOSE_MULTI = 'CHOOSE_MULTI',
  VIEW = 'VIEW'
}
